import { useState, useEffect } from 'react';
import { REMINDER_PRESETS, isValidOffset, isCustomOffset } from './Types/ReminderOffset';

/**
 * useReminderEditor — form state for editing a reminder offset string.
 * Knows nothing about CalEvent, rk, or dialogs — operates on a plain string.
 * @param {string} initialValue - current offset string (e.g. "30m"), or ''
 * @param {boolean} active - re-syncs form state from initialValue when this flips to true
 * @returns {{
 *   selected: string,
 *   custom: string,
 *   activeValue: string,
 *   isValid: boolean,
 *   setPreset: function(string): void,
 *   setCustom: function(string): void,
 * }}
 */
export function useReminderEditor(initialValue, active) {
    const [selected, setSelected] = useState(REMINDER_PRESETS[0].value);
    const [custom, setCustomValue] = useState('');

    useEffect(() => {
        if (!active) return;

        const current = initialValue ?? '';
        if (isCustomOffset(current)) {
            setSelected('__custom__');
            setCustomValue(current);
        } else {
            setSelected(current);
            setCustomValue('');
        }
    }, [active, initialValue]);

    const activeValue = selected === '__custom__' ? custom : selected;
    const isValid = isValidOffset(activeValue);

    return {
        selected,
        custom,
        activeValue,
        isValid,
        setPreset: setSelected,
        setCustom: setCustomValue,
    };
}
